module.exports = __webpack_public_path__ + "june-24-cover.jpg?bc25dd27e9ae89ad7fc5e5adcc879f38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/june-24-cover.jpg
// module id = 220
// module chunks = 0